/**************************************************************************
 * Created on Thu Nov 28 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import React, { useEffect } from 'react';
import './App.scss';

import { AppModule } from './app-router/app-router';
import DLSSnackbar from './ui/dls/dls-snackbar';

declare global {
  interface Window {
    OptanonWrapper: () => void;
  }
}
function App() {

  function loadScripts() {

    if ((window as any).__oneTrustLoaded) {
      return;
    }
    // Create the first script element for OtAutoBlock.js
    var script1 = document.createElement('script');
    script1.type = 'text/javascript';
    // @ts-ignore
    script1.src = window.ENV.COOKIE_LAW + "/" + window.ENV.COOKIE_NOTICE_ID + '/OtAutoBlock.js';
    // Create the second script element for otSDKStub.js
    
    var script2 = document.createElement('script');
    script2.type = 'text/javascript';
    // @ts-ignore
    script2.src = window.ENV.COOKIE_NOTICE_URL;
    script2.setAttribute('data-document-language', 'true');
    // @ts-ignore
    script2.setAttribute('data-domain-script', window.ENV.COOKIE_NOTICE_ID);
 
    // Create a function for OptanonWrapper
    window.OptanonWrapper = function () { };
 
    // Append scripts to the document head
    document.head.appendChild(script1);
    document.head.appendChild(script2);

    (window as any).__oneTrustLoaded = true;
  }
  useEffect(() => {
    loadScripts();
  }, []);

  return (
    <div className='appcontainer'>
      <DLSSnackbar />
      <AppModule />
    </div >
  );
};

export default App;
